<template>
  <div class="search-block">
    <form class="search-form" @submit.prevent="handleSubmit">
      <el-input
        v-model="value"
        :placeholder="placeholder"
        @input="sendRequest"
        @focus="handleFocus"
      >
        <i slot="prefix" class="search-form__icon-search"></i>
      </el-input>

      <transition name="el-zoom-in-top">
        <div
          v-if="currentRouteName !== 'Search' && countValue > 1 && openSearchArea"
          v-loading="loading"
          class="search-form__results"
        >
          <div v-if="searchResults.length" class="search-form-dropdown">
            <el-scrollbar
              wrap-class="search-form-dropdown__wrap"
              view-class="search-form-dropdown__view"
              :native="false"
            >
              <div class="search-form-dropdown__list">
                <a
                  v-for="(item, index) in searchResults"
                  class="search-form-dropdown__item"
                  :key="index"
                  @click.prevent="goToResource($event, item.tablename, item.id)"
                >
                  <i
                    class="search-form-dropdown__icon"
                    :class="{
                      'search-form-dropdown__icon_users':
                        item.tablename === 'users',
                      'search-form-dropdown__icon_companies':
                        item.tablename === 'companies',
                      'search-form-dropdown__icon_projects':
                        item.tablename === 'projects',
                    }"
                  ></i>
                  <span v-if="item.name" class="search-form-dropdown__title">
                    {{ item.name }}
                  </span>
                  <span
                    v-if="item.tablename"
                    class="search-form-dropdown__descr"
                  >
                    {{ item.category }}
                  </span>
                </a>
              </div>
              <div
                v-if="dataResults.total > 8"
                class="search-form-dropdown__more"
              >
                <el-button
                  type="primary el-button--stretch"
                  native-type="button"
                  @click.prevent="handleSubmit"
                >
                  Все результаты
                </el-button>
              </div>
            </el-scrollbar>
          </div>
          <div v-else class="search-form__results-no">
            Нет результатов
          </div>
        </div>
      </transition>
    </form>
  </div>
</template>

<script>
import breakpoints from '../../js/breakpoints'

export default {
  name: 'Search',

  data() {
    return {
      loading: false,
      dataResults: null,
      searchResults: [],
      value: '',
      countValue: null,
      openSearchArea: false,
      timeout: null,
    }
  },

  computed: {
    currentRouteName() {
      return this.$route.name
    },
		placeholder(){
			return window.innerWidth > breakpoints['sm-max'] ? 'Искать компанию, проект, сотрудника...' : 'Поиск'
		}
  },

  mounted() {
    document.addEventListener(
      'click',
      e => {
        if (this.openSearchArea && !e.target.closest('.search-form')) {
          this.openSearchArea = false
        }
      },
      true,
    )

    document.addEventListener('keyup', e => {
      if (this.openSearchArea && e.key === 'Escape') {
        this.openSearchArea = false
      }
    })
  },

  methods: {
    handleFocus() {
      this.openSearchArea = true
    },

    sendRequest() {
      clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        const val = this.value.trim()
        this.countValue = val.length // Need for show/hide the search dropdown
        this.$store.commit('Search/setData', {
          label: 'searchTextQuery',
          data: val,
        })
        if (this.currentRouteName !== 'Search') {
          this.remoteMethod(val)
        }
      }, 400)
    },

    remoteMethod(val) {
      if (val.length > 1) {
        this.loading = true
        const params = {
          query: val,
          page: 1,
          pageCount: 8,
        }
        this.$store
          .dispatch('Search/getResults', params)
          .then(({ data }) => {
            this.loading = false
            this.dataResults = data.data
            const dataList = this.dataResults.data
            this.searchResults = dataList.map(item => ({
              ...item,
              category:
                item.tablename === 'users'
                  ? 'Работник'
                  : item.tablename === 'companies'
                  ? 'Компания'
                  : 'Проект',
            }))
            this.openSearchArea = true
          })
          .catch(err => {
            console.error(err.response)
          })
      } else {
        this.searchResults = []
      }
    },

    handleSubmit() {
      if (this.currentRouteName !== 'Search') {
        this.$router.push({ name: 'Search' })
      }
      this.openSearchArea = false
    },

    goToResource(e, tablename, id) {
      this.openSearchArea = false
      const showDetails = function() {
        this.$store
          .dispatch('Company/getCompany', { id: id })
          .then(({ data }) => {
            this.loading = false
            this.$store.commit('Option/setData', {
              label: 'detailCompany',
              data: data.data,
            })
            this.$store.commit('Option/setData', {
              label: 'currentOption',
              data: 'CompanyCard',
            })
          })
      }
      switch (tablename) {
        case 'projects':
          if (this.$route.params.id !== id) {
            this.$router.push({ name: 'Project', params: { id: id } })
          }
          break
        case 'users':
          if (this.$route.params.id !== id) {
            this.$router.push({ name: 'Employee', params: { id: id } })
          }
          break
        case 'companies':
          if (this.$route.name === 'Companies') {
            showDetails.call(this)
          } else {
            this.$router.push({ name: 'Companies' }).then(() => {
              showDetails.call(this)
            })
          }
          break
      }
    },
  },
}
</script>

<style lang="scss">
@import 'src/assets/styles/helpers/mixin';
@import 'src/assets/styles/helpers/variables';

.search-form {
  position: relative;

  .el-input__inner {
    padding: 0 1.5rem 0 5.2rem;
    height: 4.2rem;
    font-size: 1.4rem;
    line-height: 4.2rem;
    color: #31333b;
    background: #fff;
    box-shadow: 4px 4px 24px rgba(70, 80, 119, 0.04);
    border-radius: 6px;
    border: none;
  }

  .el-input__suffix {
    display: none;
  }

  &__icon-search {
    display: block;
    height: 100%;
    width: calc(5.2rem - 5px);
    cursor: pointer;

    &::before {
      content: '';
      display: block;
      position: absolute;
      right: 0.4rem;
      top: 50%;
      height: 2.4rem;
      width: 2.4rem;
      margin-top: -1.2rem;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 18C11.775 17.9996 13.4988 17.4054 14.897 16.312L19.293 20.708L20.707 19.294L16.311 14.898C17.405 13.4997 17.9996 11.7754 18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18ZM10 4C13.309 4 16 6.691 16 10C16 13.309 13.309 16 10 16C6.691 16 4 13.309 4 10C4 6.691 6.691 4 10 4Z' fill='%23A2A7BE'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }

  &__results {
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    background: #fff;
    box-shadow: 4px 4px 32px rgba(70, 80, 119, 0.24);
    border-radius: 6px;
    margin: 0.4rem 0;
    max-width: 100%;

    &-no {
      padding: 1rem 2.4rem;
      text-align: center;
      color: #676973;
    }
  }
}

.search-form-dropdown {
  &__wrap {
    max-height: calc(41.6rem + 17px);
  }

  &__view {
    padding: 2rem 0.4rem;
  }

  &__item {
    display: block;
    padding: 1.2rem 2rem;
    color: $text;
    font-size: 14px;
    line-height: 19px;
    text-decoration: none;
    cursor: pointer;
    border-radius: 6px;
    transition: background-color $transition-duration;

    @include clearfix;

    &:focus {
      background: #f3f4f5;
    }

    &:hover {
      background: #f1f2f3;
    }
  }

  &__icon {
    float: left;
    width: 4.8rem;
    height: 4.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background-color: #d0d0d0;

    &::before {
      content: '';
      display: block;
      height: 2.4rem;
      width: 2.4rem;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 6C20.58 6 21.05 6.2 21.42 6.59C21.8 7 22 7.45 22 8V19C22 19.55 21.8 20 21.42 20.41C21.05 20.8 20.58 21 20 21H4C3.42 21 2.95 20.8 2.58 20.41C2.2 20 2 19.55 2 19V8C2 7.45 2.2 7 2.58 6.59C2.95 6.2 3.42 6 4 6H8V4C8 3.42 8.2 2.95 8.58 2.58C8.95 2.2 9.42 2 10 2H14C14.58 2 15.05 2.2 15.42 2.58C15.8 2.95 16 3.42 16 4V6H20ZM4 8V19H20V8H4ZM14 6V4H10V6H14Z' fill='white'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    &_users {
      background-color: #d0defb;

      &::before {
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M22.5 21C22.5 21 24 21 24 19.5C24 18 22.5 13.5 16.5 13.5C10.5 13.5 9 18 9 19.5C9 21 10.5 21 10.5 21H22.5ZM10.5075 19.584V19.581V19.584ZM10.533 19.5H22.467C22.474 19.4992 22.481 19.4982 22.488 19.497L22.5 19.494C22.497 19.098 22.2495 17.949 21.36 16.914C20.532 15.9435 19.077 15 16.5 15C13.9245 15 12.4695 15.945 11.64 16.914C10.7505 17.949 10.5015 19.0995 10.5 19.494C10.511 19.4961 10.522 19.4981 10.533 19.5ZM22.4925 19.584V19.581V19.584ZM16.5 10.5C17.2956 10.5 18.0587 10.1839 18.6213 9.62132C19.1839 9.05871 19.5 8.29565 19.5 7.5C19.5 6.70435 19.1839 5.94129 18.6213 5.37868C18.0587 4.81607 17.2956 4.5 16.5 4.5C15.7044 4.5 14.9413 4.81607 14.3787 5.37868C13.8161 5.94129 13.5 6.70435 13.5 7.5C13.5 8.29565 13.8161 9.05871 14.3787 9.62132C14.9413 10.1839 15.7044 10.5 16.5 10.5ZM21 7.5C21 8.09095 20.8836 8.67611 20.6575 9.22208C20.4313 9.76804 20.0998 10.2641 19.682 10.682C19.2641 11.0998 18.768 11.4313 18.2221 11.6575C17.6761 11.8836 17.0909 12 16.5 12C15.9091 12 15.3239 11.8836 14.7779 11.6575C14.232 11.4313 13.7359 11.0998 13.318 10.682C12.9002 10.2641 12.5687 9.76804 12.3425 9.22208C12.1164 8.67611 12 8.09095 12 7.5C12 6.30653 12.4741 5.16193 13.318 4.31802C14.1619 3.47411 15.3065 3 16.5 3C17.6935 3 18.8381 3.47411 19.682 4.31802C20.5259 5.16193 21 6.30653 21 7.5ZM10.404 13.92C9.80397 13.7311 9.18545 13.6069 8.559 13.5495C8.207 13.516 7.85359 13.4995 7.5 13.5C1.5 13.5 0 18 0 19.5C0 20.5005 0.4995 21 1.5 21H7.824C7.60163 20.5317 7.49074 20.0183 7.5 19.5C7.5 17.985 8.0655 16.437 9.135 15.144C9.4995 14.703 9.924 14.2905 10.404 13.92ZM7.38 15C4.878 15.03 3.4575 15.96 2.64 16.914C1.7445 17.955 1.5 19.1085 1.5 19.5H6C6 17.9325 6.4845 16.371 7.38 15ZM2.25 8.25C2.25 7.05653 2.72411 5.91193 3.56802 5.06802C4.41193 4.22411 5.55653 3.75 6.75 3.75C7.94347 3.75 9.08807 4.22411 9.93198 5.06802C10.7759 5.91193 11.25 7.05653 11.25 8.25C11.25 9.44347 10.7759 10.5881 9.93198 11.432C9.08807 12.2759 7.94347 12.75 6.75 12.75C5.55653 12.75 4.41193 12.2759 3.56802 11.432C2.72411 10.5881 2.25 9.44347 2.25 8.25ZM6.75 5.25C5.95435 5.25 5.19129 5.56607 4.62868 6.12868C4.06607 6.69129 3.75 7.45435 3.75 8.25C3.75 9.04565 4.06607 9.80871 4.62868 10.3713C5.19129 10.9339 5.95435 11.25 6.75 11.25C7.54565 11.25 8.30871 10.9339 8.87132 10.3713C9.43393 9.80871 9.75 9.04565 9.75 8.25C9.75 7.45435 9.43393 6.69129 8.87132 6.12868C8.30871 5.56607 7.54565 5.25 6.75 5.25Z' fill='white'/%3E%3C/svg%3E%0A");
      }
    }

    &_companies {
      background-color: #95e0aa;

      &::before {
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 6C20.58 6 21.05 6.2 21.42 6.59C21.8 7 22 7.45 22 8V19C22 19.55 21.8 20 21.42 20.41C21.05 20.8 20.58 21 20 21H4C3.42 21 2.95 20.8 2.58 20.41C2.2 20 2 19.55 2 19V8C2 7.45 2.2 7 2.58 6.59C2.95 6.2 3.42 6 4 6H8V4C8 3.42 8.2 2.95 8.58 2.58C8.95 2.2 9.42 2 10 2H14C14.58 2 15.05 2.2 15.42 2.58C15.8 2.95 16 3.42 16 4V6H20ZM4 8V19H20V8H4ZM14 6V4H10V6H14Z' fill='white'/%3E%3C/svg%3E%0A");
      }
    }

    &_projects {
      background-color: #d7aee5;

      &::before {
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 13.5H9V15H6V13.5Z' fill='white'/%3E%3Cpath d='M10.5 13.5H13.5V15H10.5V13.5Z' fill='white'/%3E%3Cpath d='M6 10.5H9V12H6V10.5Z' fill='white'/%3E%3Cpath d='M10.5 16.5H13.5V18H10.5V16.5Z' fill='white'/%3E%3Cpath d='M15 10.5H18V12H15V10.5Z' fill='white'/%3E%3Cpath d='M15 16.5H18V18H15V16.5Z' fill='white'/%3E%3Cpath d='M20.25 2.25H3.75C3.3523 2.2504 2.971 2.40856 2.68978 2.68978C2.40856 2.971 2.2504 3.3523 2.25 3.75V20.25C2.2504 20.6477 2.40856 21.029 2.68978 21.3102C2.971 21.5914 3.3523 21.7496 3.75 21.75H20.25C20.6477 21.7496 21.029 21.5914 21.3102 21.3102C21.5914 21.029 21.7496 20.6477 21.75 20.25V3.75C21.7496 3.3523 21.5914 2.971 21.3102 2.68978C21.029 2.40856 20.6477 2.2504 20.25 2.25ZM20.25 3.75V6.75H3.75V3.75H20.25ZM3.75 20.25V8.25H20.25V20.25H3.75Z' fill='white'/%3E%3C/svg%3E%0A");
      }
    }
  }

  &__title {
    display: block;
    padding: 0.3rem 0 0 5.6rem;
    font-weight: 600;
    color: $text;
    margin-bottom: 1px;
  }

  &__descr {
    display: block;
    padding: 0.3rem 0 0 5.6rem;
    color: #676973;
  }

  &__more {
    padding: 1.2rem 2rem;
  }
}

.search-block {
  .search-form {
    width: 100%;
  }
}

@media (max-width: $screen-sm-max){
	.search-form{
		.el-input__inner{
			height: 40px;
			line-height: 40px;
			padding-left: 10px;
			padding-right: 50px;
		}
		.el-input__prefix{
			right: 0;
			left: auto;
			width: auto;
		}
		.search-form__icon-search{
			width: 50px;
			filter: brightness(0) saturate(100%) invert(47%) sepia(36%) saturate(1964%) hue-rotate(172deg) brightness(98%) contrast(92%);

			&::before{
				right: 10px;
			}
		}
		.search-form-dropdown__view{
			padding: 8px 5px;
		}
		.search-form-dropdown__item{
			padding: 15px;
		}
		.search-form-dropdown__icon{
			width: 32px;
			height: 32px;

			&::before{
				width: 16px;
				height: 16px;
			}
		}
		.search-form-dropdown__title{
			padding-left: 40px;
			padding-top: 0;
			font-weight: 400;
			margin-top: -5px;
		}
		.search-form-dropdown__descr{
			padding-left: 40px;
			padding-top: 0;
		}
	}
}
</style>
